import { RefObject, useEffect } from 'react';
import { useColumnFilterRegistryContext } from '../context/useColumnFilterRegistryContext';
import { QUICK_FILTER_COLUMN_ATTR } from '../../constants';
import { GridColumn } from '../../components/Manager/Grid/types';

// Wires PrimeReact filter menu buttons into the column filter registry so the quick-filter shortcut can click them by column name.
export const useColumnTriggerRegistrations = (
  columns: GridColumn[],
  gridRef: RefObject<HTMLElement | any>
) => {
  const { registerTriggerRef } = useColumnFilterRegistryContext();

  useEffect(() => {
    const gridElement = gridRef.current as HTMLElement | null;
    if (!gridElement) return;

    // Register only columns with filter.
    const unregisterCallbacks = columns
      .filter((column) => column.hasFilter)
      .map((column) => {
        // Look up the button on each read (getter), not once now, so the ref still works after the grid re-renders (loading, scroll, re-sort).
        const triggerRef: RefObject<HTMLElement | null> = {
          get current() {
            return gridElement.querySelector(
              `[${QUICK_FILTER_COLUMN_ATTR}="${column.name}"]`
            ) as HTMLElement | null;
          },
        };
        return registerTriggerRef(column.name, triggerRef);
      });

    return () => unregisterCallbacks.forEach((unregister) => unregister());
  }, [columns, registerTriggerRef, gridRef]);
};
